export default {
    title: 'Notifications',
    notification: 'Notifications',
    see_all: 'See All',
    no_notification: 'List empty',
    show_unread: 'Only show unread',
    alert_retention_period:
        'The notification will be deleted after {retentionPeriod}',
};
